import { Typography } from "@mui/material";

import { Link } from "components/html/Link";

import { i18n } from "services/i18nService";

export function PayPal() {
  return (
    <>
      <Typography sx={{ mt: 1 }}>
        {i18n("cart.PayPal.instructions.header")}
      </Typography>
      <ol>
        <li>{i18n("cart.PayPal.instructions.1")}</li>
        <ol type="A">
          <li>
            {i18n("cart.PayPal.instructions.1.1.1")}{" "}
            <Link
              component="a"
              rel="noreferrer"
              href="https://www.paypal.com/"
              target="_blank"
            >
              {i18n("cart.PayPal.instructions.1.1.2")}
            </Link>{" "}
            {i18n("cart.PayPal.instructions.1.1.3")}
          </li>
          <li>{i18n("cart.PayPal.instructions.1.2")}</li>
          <li>{i18n("cart.PayPal.instructions.1.3")}</li>
          <li>{i18n("cart.PayPal.instructions.1.4")}</li>
          <li>{i18n("cart.PayPal.instructions.1.5")}</li>
          <li>{i18n("cart.PayPal.instructions.1.6")}</li>
          <li>{i18n("cart.PayPal.instructions.1.7")}</li>
          <div>
            <img
              src="/images/paypal_setup.png"
              style={{ width: "600px", height: "auto" }}
              alt="PayPal setup"
            />
          </div>
          <li>{i18n("cart.PayPal.instructions.1.8")}</li>
        </ol>
        <li>{i18n("cart.PayPal.instructions.2")}</li>
        <li>
          {i18n("cart.PayPal.instructions.3.1")}{" "}
          <Link
            component="a"
            rel="noreferrer"
            href="https://help.sosinventory.com/home"
            target="_blank"
          >
            {i18n("cart.link.instructions.SosHelpCenter")}
          </Link>{" "}
          {i18n("cart.PayPal.instructions.3.2")}
        </li>
      </ol>
    </>
  );
}
